export const formatFrequency = (frequencyHz) => {
  
  const units = ["Hz", "kHz", "MHz"];

  if(frequencyHz === null || frequencyHz === undefined)
    return "N/A"
  
  let value = frequencyHz;
  let unitIndex = 0;
  
  while (value >= 1000 && unitIndex < units.length - 1) {
    value /= 1000;
    unitIndex++;
  }

  return `${value.toFixed(2)} ${units[unitIndex]}`;
};


/**
 * Converts a duration in seconds into a readable format:
 * "X years Y months Z days H hours M minutes S seconds"
 *
 * @param {number} totalSeconds - The duration in seconds
 * @returns {string} A formatted duration string
 */
export function formatDuration(totalSeconds) {
  if (isNaN(totalSeconds) || totalSeconds < 0) return "0 seconds";

  const SECONDS_IN_MINUTE = 60;
  const SECONDS_IN_HOUR = 3600;
  const SECONDS_IN_DAY = 86400;
  const SECONDS_IN_MONTH = SECONDS_IN_DAY * 30.44; // average month length
  const SECONDS_IN_YEAR = SECONDS_IN_DAY * 365.25; // average year length

  const years = Math.floor(totalSeconds / SECONDS_IN_YEAR);
  totalSeconds %= SECONDS_IN_YEAR;

  const months = Math.floor(totalSeconds / SECONDS_IN_MONTH);
  totalSeconds %= SECONDS_IN_MONTH;

  const days = Math.floor(totalSeconds / SECONDS_IN_DAY);
  totalSeconds %= SECONDS_IN_DAY;

  const hours = Math.floor(totalSeconds / SECONDS_IN_HOUR);
  totalSeconds %= SECONDS_IN_HOUR;

  const minutes = Math.floor(totalSeconds / SECONDS_IN_MINUTE);
  const seconds = Math.floor(totalSeconds % SECONDS_IN_MINUTE);

  const parts = [];
  if (years) parts.push(`${years} year${years > 1 ? "s" : ""}`);
  if (months) parts.push(`${months} month${months > 1 ? "s" : ""}`);
  if (days) parts.push(`${days} day${days > 1 ? "s" : ""}`);
  if (hours) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
  if (minutes) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
  if (seconds || parts.length === 0)
    parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);

  return parts.join(" ");
}

export const buildStationDetailsPayload = (payload) => {
    const newPayload = structuredClone(payload); // or deep copy

    const setSis = () => {
      newPayload.sis = newPayload.sis || {};
      newPayload.sis.hostname = `sis.${newPayload.identifier?.toLowerCase()}.echo.roinspace.com`;
      newPayload.sis.port = 80;
    };

    const setInt = () => {
      const dirs = ["north", "east", "south", "west"];
      newPayload.int = newPayload.int || {};

      dirs.forEach((dir) => {
        newPayload.int[dir] = newPayload.int[dir] || {};
        newPayload.int[dir].hostname =
          `${dir}.int.${newPayload.identifier?.toLowerCase()}.echo.roinspace.com`;
        newPayload.int[dir].port = 80;
      });
    };

    switch (newPayload.type) {
      case "PERFORMANCE":
        delete newPayload.int;
        if (!newPayload.isSelfHosted) setSis();
        break;

      case "LOCALIZATION":
        delete newPayload.sis;
        if (!newPayload.isSelfHosted) setInt();
        break;

      case "PERFORMANCE_AND_LOCALIZATION":
        if (!newPayload.isSelfHosted) {
          setSis();
          setInt();
        }
        break;
    }

    return newPayload;
  };